import { initCartWidget, visibilityCartWidget } from './cart-widget.js';
import { renderCart } from './cart.js';
import { updateCatalogCardStatus, saveCatalogCard } from './catalog-card.js';
import {sendOrderForm} from './order-form.js';
import {initModal} from './order-modal.js';

import './info-tooltip.js';

function initServiceCatalog() {
  let cart = [];

  const savedCart = localStorage.getItem('serviceCatalogCart');

  if (savedCart) {
    cart = JSON.parse(savedCart);
  }

  console.log(cart);

  renderCart(cart);
  initCartWidget();
  updateCatalogCardStatus(cart);
  saveCatalogCard(cart);
  sendOrderForm(cart);
  visibilityCartWidget(cart);
  initModal();
}

initServiceCatalog();

const catalogCarouselTrack = new Swiper('.catalog-carousel__track', {
  loop: true,
  slidesPerView: 3,
  spaceBetween: 30,
  pagination: {
    el: '.catalog-carousel__pagination',
    clickable: true,
    bulletClass: 'catalog-carousel__bullet',
    bulletActiveClass: 'catalog-carousel__bullet--active',
  },
  breakpoints: {
    0: {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            enabled: false
        }
    },
    768: {
        slidesPerView: 2,
        spaceBetween: 58,
        navigation: {
            enabled: false
        }
    },

    1200: {
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
          nextEl: '.catalog-carousel__button--next',
          prevEl: '.catalog-carousel__button--prev',
        },
    }
  }
});